module.exports = __webpack_public_path__ + "static/media/failed.c4f75a59.png";